import React, { Component } from 'react';

import SideMenu from './SideMenu';
import Dashboard from '../dashboard';
import SalesReport from '../sales-report';
import Orders from '../orders';
import OrderDetail from '../orders/Detail';
import ProductsIndex from '../products';
import Blogs from '../blogs';
import Promotions from '../promotions';
import HighlighProducts from '../products/HighlightProducts';
import Slideshow from '../slideshow';
import Members from '../members';
import Settings from '../settings';
import FirstSectionContent from '../first-section-content';

class Main extends Component {
    render () {
        const { match, history, location } = this.props;

        let contentView;
        let containerStyle = { height: '100vh' };
        let menuActiveComponent = match.params.page;

        if (match.path === '/orders/:uid/:orderId') {
            const orderId = match.params.orderId;

            contentView = <OrderDetail match={match} history={history} location={location} />;
            menuActiveComponent = 'orders';
            containerStyle = { height: '100%' };

        } else {
            switch (match.params.page) {
                case 'sales-report':
                    contentView = <SalesReport />;
                    break;
                case 'orders':
                    contentView = <Orders match={match} history={history} location={location} />;
                    break;
                case 'products':
                    contentView = <ProductsIndex match={match} history={history} location={location} />;
                    break;
                case 'blogs':
                    contentView = <Blogs match={match} history={history} location={location} />;
                    break;
                case 'promotions':
                    contentView = <Promotions match={match} history={history} location={location} />;
                    break;
                case 'highlight-products':
                    contentView = <HighlighProducts />;
                    break;
                case 'slideshow':
                    contentView = <Slideshow />;
                    break;
                case 'members':
                    contentView = <Members />;
                    break;
                case 'settings':
                    contentView = <Settings />;
                    break;
                case 'first-section-content':
                    contentView = <FirstSectionContent match={match} history={history} location={location} />;
                break;
                default:
                    contentView = <Dashboard />;
                    menuActiveComponent = 'dashboard'
                    break;
            }
        }

        return (
            <div className="container-fluid">
                <SideMenu menuActiveComponent={menuActiveComponent}/>
                {contentView}
            </div>
        )
    }
}

export default Main


// WEBPACK FOOTER //
// ./src/views/main/index.js